import Axios from 'axios';
import api, { setAuthorizationToken } from './api';

export interface Account {
  username: string;
  password: string;
}

export interface AccountResult {
  valid: AccountResult | undefined;
  isFirstAccess: boolean;
  permissoes: string[];
  expires_in: string;
  access_token: string;
  codigoUsuario: string;
  isMRN: string;
  url: string;
  username: string;
  password: string;
}

export const loginFornecedor = (account: Account) =>
  api.post<AccountResult>('account/authenticate', account, {
    disableNotification: false,
  });

export const loginByToken = (token: any) => {
  let urlBase = window.location.origin + '/api/account/authenticateByToken';
  return Axios.get(urlBase, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const forgotPassword = (userName: string) => {
  let data = { userName: userName };
  return api.post('account/forgotPassword', data, { disableNotification: 'true' });
};

export const resetPassword = (code: string, newPassword: string, username: string) => {
  let data = { code: code, newPassword: newPassword, username: username };
  return api.post('account/resetPassword', data, { disableNotification: 'true' });
};

export const getPermissions = async () => {
  const token = localStorage.getItem('idtoken');
  if (token) {
    setAuthorizationToken(token);
  }

  return api.get('account/permissions/sso', {}, { disableNotification: false });
};